
export const TABLE = {
    CANDIDAT: "candidat",
    CONTACT: "contact",
    SOCIETE: "societe",
}